/**
 * What the enquiry action hands back to the form.
 *
 * A sibling of `enquiry-action.ts` rather than part of it: a `'use server'` module may
 * export only async functions, and this is a type and a constant.
 */

export type EnquiryField =
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'company'
  | 'kind'
  | 'message'
  | 'consent'

export type EnquiryValues = Readonly<Record<EnquiryField, string>>

export type EnquiryFieldErrors = Partial<Readonly<Record<EnquiryField, string>>>

export type EnquiryState =
  | { readonly status: 'idle' }
  | {
      readonly status: 'invalid'
      readonly errors: EnquiryFieldErrors
      readonly values: EnquiryValues
    }
  | {
      readonly status: 'failed'
      readonly reason: 'unavailable' | 'rate-limited'
      readonly values: EnquiryValues
    }
  | { readonly status: 'sent'; readonly reference: string }

export const INITIAL_ENQUIRY_STATE: EnquiryState = { status: 'idle' }

export const EMPTY_VALUES: EnquiryValues = {
  firstName: '',
  lastName: '',
  email: '',
  company: '',
  kind: '',
  message: '',
  /** `'on'` when the box was ticked: what a browser posts for a checked checkbox. */
  consent: '',
}
